import React, { useState, useEffect, useRef, useMemo } from "react";
import { Context, Util } from "@xt/xtbase";
const { XtContext } = Context;
const { getUrl } = Util;
import { Carousel } from "antd";
import { getBannerList, filterBannerListByLogin } from "@/api/xt-app";
import useUserTagFeatureEnabled from "@/hooks/useUserTagFeatureEnabled";
import { USER_TAG_GRAY_FEATURES } from "@/utils/userTagGrayRelease";
import beginnerGuideBannerImg from "assets/images/downLoad/Guide.png";
// 暂时不在轮播展示 AI 跟单策略卡
// import { get_homeStrategies, get_strategyReturnTrend } from "@/api/aicopy";
// import { getProfitColorClass } from "@/components/Pages/aicopy/utils/colorScheme";
// import ReturnRateChart from "@/components/Pages/aicopy/components/ReturnRateChart";
import { observer } from "mobx-react-lite";
import styles from "./index.module.less";
// import aicopyStyles from "../HomeAiCopy/index.module.less";
// import strategyIconAlpha10 from "assets/images/aicopy/eb3a5f42-0255-4b85-82c6-bd5462a3928b.png";
// import chevronRightIcon from "assets/images/aicopy/898172df-f017-4eff-be9d-a2b6fe27e1fa.svg";
// import tagBackground from "assets/images/aicopy/7e4271f1-feec-44a0-9dcc-aeec6f8ed213.svg";
// import tagIcon from "assets/images/aicopy/ae0a5b7b-f195-4586-9300-03ed4ed14813.svg";
// import { trackAicopyEntryClick, trackAicopySignalClick } from "@/utils/clientBehavior";

/** 与未合并前 banner 一致：antd Carousel 默认 autoplay 间隔 3000ms */
const BANNER_AUTOPLAY_SPEED_MS = 3000;
const BEGINNER_GUIDE_BANNER_ID = "beginner-guide-entry";

/** 是否为注册页路径（含 /{locale}/accounts/register 或完整 URL） */
const isRegisterLink = (link) => {
  if (!link) return false;
  let pathname = "";
  if (/^(https?:)?\/\//.test(link)) {
    try {
      pathname = new URL(link.startsWith("//") ? `https:${link}` : link).pathname;
    } catch {
      return false;
    }
  } else {
    pathname = link.split("?")[0].split("#")[0];
  }
  const p = pathname.replace(/\/$/, "") || "/";
  return /^(?:\/[^/]+)?\/accounts\/register$/.test(p);
};

// const parseStrategiesResponse = (response) => {
//   if (!response) return [];
//   if (response.code === 0 && Array.isArray(response.data)) return response.data;
//   if (response.rc === 0 && Array.isArray(response.result)) return response.result;
//   if (Array.isArray(response.data)) return response.data;
//   if (Array.isArray(response.result)) return response.result;
//   return [];
// };

// /** home 策略接口 return90d：与 /aicopy 策略列表展示口径一致（数值 + %） */
// const formatStrategyReturn90dPercent = (strategy) => {
//   const raw = strategy?.return90d ?? strategy?.return_90d;
//   if (raw == null || String(raw).trim() === "") return { text: "0%", colorValue: null };
//   const n = parseFloat(String(raw).replace(/,/g, ""));
//   if (!Number.isFinite(n)) return { text: "0%", colorValue: null };
//   const s = String(raw).replace(/,/g, "");
//   const text = n > 0 ? `+${s}%` : n < 0 ? `${s}%` : "0%";
//   return { text, colorValue: s };
// };

const HomeCampaignBanner = () => {
  // const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const { theme, loginStatus } = appState;
  const isLogin = loginStatus === 1;
  const { enabled: beginnerGuideEnabled, ready: beginnerGuideReady } = useUserTagFeatureEnabled(
    USER_TAG_GRAY_FEATURES.BEGINNER_GUIDE
  );
  const [allBanners, setAllBanners] = useState([]);
  // const [strategies, setStrategies] = useState([]);
  // /** 与 /aicopy 策略列表一致：return-trend 接口数据，供 ReturnRateChart 使用 */
  // const [strategyReturnTrends, setStrategyReturnTrends] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);

  // const loadStrategyReturnTrend = useCallback(async (strategyId) => {
  //   try {
  //     const response = await get_strategyReturnTrend(strategyId, 90, { isResFull: true });
  //     let trendData = null;
  //     if (response.rc === 0 && response.result != null) {
  //       trendData = Array.isArray(response.result) ? response.result : [response.result];
  //     } else if (response.code === 0 && response.data != null) {
  //       trendData = Array.isArray(response.data) ? response.data : [response.data];
  //     }
  //     if (trendData && trendData.length > 0) {
  //       setStrategyReturnTrends((prev) => ({ ...prev, [strategyId]: trendData }));
  //     }
  //   } catch (e) {
  //     console.error(`首页 banner 策略 ${strategyId} 收益率走势失败`, e);
  //   }
  // }, []);

  const bannerList = useMemo(() => {
    const apiBanners = filterBannerListByLogin(allBanners, isLogin);
    if (!beginnerGuideReady || !beginnerGuideEnabled) return apiBanners;
    return [
      ...apiBanners,
      {
        id: BEGINNER_GUIDE_BANNER_ID,
        link: "/beginner-guide",
        staticImage: beginnerGuideBannerImg,
      },
    ];
  }, [allBanners, isLogin, beginnerGuideReady, beginnerGuideEnabled]);

  // /** 展示接口返回的全部 AI 策略，不截断条数 */
  // const aiList = strategies;

  const totalSlides = bannerList.length;

  useEffect(() => {
    setCurrentIndex((i) => (totalSlides && i >= totalSlides ? 0 : i));
  }, [totalSlides]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const bannerRes = await getBannerList({ params: { type: 1, actType: 0 } }).catch(() => null);
        // const [bannerRes, strategiesRes] = await Promise.all([
        //   getBannerList({ params: { type: 1, actType: 0 } }).catch(() => null),
        //   get_homeStrategies({ isResFull: true }).catch(() => null),
        // ]);
        if (!cancelled) {
          if (bannerRes && Array.isArray(bannerRes) && bannerRes.length > 0) {
            setAllBanners(bannerRes);
          } else {
            setAllBanners([]);
          }
          // const list = parseStrategiesResponse(strategiesRes);
          // setStrategies(list);
          // list.forEach((s) => {
          //   if (s?.strategyId) loadStrategyReturnTrend(s.strategyId);
          // });
        }
      } catch {
        if (!cancelled) {
          setAllBanners([]);
          // setStrategies([]);
        }
      } finally {
        if (!cancelled) setDataLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const getBannerImg = (item) => {
    if (!item) return "";
    if (item.staticImage) return item.staticImage;
    if (theme === "dark") {
      return item.nightBannerWebP || item.nightBanner || item.dayBannerWebP || item.dayBanner || "";
    }
    return item.dayBannerWebP || item.dayBanner || item.nightBannerWebP || item.nightBanner || "";
  };

  const handleBannerClick = (item) => {
    if (!item) return;
    if (item.id === BEGINNER_GUIDE_BANNER_ID || item.link === "/beginner-guide") {
      window.location.href = getUrl("/beginner-guide");
      return;
    }
    if (!item.link) return;
    const link = item.link;
    if (isLogin && isRegisterLink(link)) return;
    const isHttp = /^(https?:)?\/\//.test(link);
    if (isHttp) {
      window.open(link);
    } else {
      window.location.href = getUrl(link);
    }
  };

  // const handleStrategyClick = (strategy) => {
  //   const strategyId = strategy?.strategyId;
  //   if (strategyId) {
  //     trackAicopySignalClick({
  //       symbol: String(strategy?.symbol || strategy?.tradingPair || "")
  //         .replace(/_/g, "")
  //         .toUpperCase(),
  //       modelId: String(strategyId),
  //       pagePath: typeof window !== "undefined" ? window.location.pathname : "",
  //     });
  //     window.location.href = getUrl(`/aicopy/${strategyId}`);
  //   }
  // };

  // const handleUseStrategy = (e, strategy) => {
  //   e.stopPropagation();
  //   const strategyId = strategy?.strategyId;
  //   if (strategyId) {
  //     trackAicopySignalClick({
  //       symbol: String(strategy?.symbol || strategy?.tradingPair || "")
  //         .replace(/_/g, "")
  //         .toUpperCase(),
  //       modelId: String(strategyId),
  //       pagePath: typeof window !== "undefined" ? window.location.pathname : "",
  //     });
  //     window.location.href = getUrl(`/aicopy/${strategyId}`);
  //   }
  // };

  const handleChange = (current) => {
    setCurrentIndex(current);
  };

  // const renderAiSlide = (strategy) => {
  //   const return90dDisplay = formatStrategyReturn90dPercent(strategy);
  //
  //   return (
  //   <div
  //     className={`${aicopyStyles["home-aicopy__card"]} ${aicopyStyles["home-aicopy__card--bannerEmbed"]}`}
  //     onClick={() => handleStrategyClick(strategy)}
  //     role="button"
  //   >
  //     <div className={aicopyStyles["home-aicopy__banner-top"]}>
  //       <div className={aicopyStyles["home-aicopy__banner-top-left"]}>
  //         <div className={aicopyStyles["home-aicopy__icon-wrapper"]}>
  //           <img
  //             src={strategy.avatarUrl || strategyIconAlpha10}
  //             alt={strategy.strategyName}
  //             className={aicopyStyles["home-aicopy__icon"]}
  //           />
  //         </div>
  //         <div className={aicopyStyles["home-aicopy__banner-name-inline"]}>
  //           <span className={aicopyStyles["home-aicopy__name"]}>{strategy.strategyName}</span>
  //           <img src={chevronRightIcon} alt="" className={aicopyStyles["home-aicopy__banner-chevron"]} aria-hidden />
  //           <div className={aicopyStyles["home-aicopy__banner-strategy-tags"]}>
  //             {strategy.tags && strategy.tags.length > 0
  //               ? strategy.tags.map((tag, index) => (
  //                   <div key={index} className={aicopyStyles["home-aicopy__banner-tag-item"]}>
  //                     <div className={aicopyStyles["home-aicopy__banner-tag-bg"]}>
  //                       <img src={tagBackground} alt="" className={aicopyStyles["home-aicopy__banner-tag-bg-img"]} />
  //                     </div>
  //                     <div className={aicopyStyles["home-aicopy__banner-tag-icon"]}>
  //                       <img src={tagIcon} alt="" />
  //                     </div>
  //                     <span className={aicopyStyles["home-aicopy__banner-tag-text"]}>{tag}</span>
  //                   </div>
  //                 ))
  //               : null}
  //           </div>
  //         </div>
  //       </div>
  //       <button
  //         type="button"
  //         className={`${aicopyStyles["home-aicopy__use-btn"]} ${aicopyStyles["home-aicopy__use-btn--bannerEmbed"]}`}
  //         onClick={(e) => handleUseStrategy(e, strategy)}
  //       >
  //         {t("aicopy.use") || "Use"}
  //       </button>
  //     </div>
  //     <div className={aicopyStyles["home-aicopy__banner-stats"]}>
  //       <div className={aicopyStyles["home-aicopy__banner-stat"]}>
  //         <div
  //           className={`${aicopyStyles["home-aicopy__banner-stat-value"]} ${getProfitColorClass(strategy.totalProfit, aicopyStyles)}`}
  //         >
  //           {strategy.totalProfit || "0.00"}
  //         </div>
  //         <div className={aicopyStyles["home-aicopy__banner-stat-label"]}>{t("aicopy.strategyPnl")}</div>
  //       </div>
  //       <div className={aicopyStyles["home-aicopy__banner-stat"]}>
  //         <div
  //           className={`${aicopyStyles["home-aicopy__banner-stat-value"]} ${getProfitColorClass(return90dDisplay.colorValue, aicopyStyles)}`}
  //         >
  //           {return90dDisplay.text}
  //         </div>
  //         <div className={aicopyStyles["home-aicopy__banner-stat-label"]}>{t("aicopy.returnRate")}</div>
  //       </div>
  //       <div className={aicopyStyles["home-aicopy__banner-chart"]}>
  //         {strategyReturnTrends[strategy.strategyId] && strategyReturnTrends[strategy.strategyId].length > 0 ? (
  //           <div className={aicopyStyles["home-aicopy__banner-strategy-chart"]}>
  //             <ReturnRateChart data={strategyReturnTrends[strategy.strategyId]} />
  //           </div>
  //         ) : null}
  //       </div>
  //     </div>
  //   </div>
  //   );
  // };

  const renderBannerSlide = (item, index) => {
    const imageSrc = getBannerImg(item);
    return (
    <div key={`banner-${item?.id ?? index}`} className={styles["campaign-banner__slide"]}>
      <div className={styles["campaign-banner__card"]} onClick={() => item && handleBannerClick(item)}>
        {imageSrc ? (
          <img src={imageSrc} alt={item.title || ""} className={styles["campaign-banner__image-full"]} />
        ) : null}
      </div>
    </div>
    );
  };

  // const renderAiCarouselSlide = (strategy) => (
  //   <div key={`aicopy-${strategy.strategyId}`} className={styles["campaign-banner__slide"]}>
  //     <div className={`${styles["campaign-banner__card"]} ${styles["campaign-banner__card--aicopy"]}`}>
  //       {renderAiSlide(strategy)}
  //     </div>
  //   </div>
  // );

  if (!dataLoaded || totalSlides === 0) {
    return null;
  }

  return (
    <div className={styles["campaign-banner"]}>
      <div className={styles["campaign-banner__container"]}>
        <div className={styles["campaign-banner__carousel-wrapper"]}>
          {totalSlides > 1 ? (
            <Carousel
              ref={carouselRef}
              autoplay
              autoplaySpeed={BANNER_AUTOPLAY_SPEED_MS}
              dots={false}
              afterChange={handleChange}
              className={styles["campaign-banner__carousel"]}
            >
              {bannerList.map((item, index) => renderBannerSlide(item, index))}
              {/* {aiList.map((strategy) => renderAiCarouselSlide(strategy))} */}
            </Carousel>
          ) : (
            <div className={styles["campaign-banner__slide"]}>
              <div className={styles["campaign-banner__card"]}>
                {getBannerImg(bannerList[0]) ? (
                  <img
                    src={getBannerImg(bannerList[0])}
                    alt={bannerList[0].title || ""}
                    className={styles["campaign-banner__image-full"]}
                    onClick={() => handleBannerClick(bannerList[0])}
                  />
                ) : null}
              </div>
            </div>
          )}
        </div>

        {totalSlides > 1 && (
          <div className={styles["campaign-banner__footer-wrapper"]}>
            <div className={styles["campaign-banner__pagination"]}>
              {Array.from({ length: totalSlides }).map((_, index) => (
                <span
                  key={`indicator-${index}`}
                  className={styles["campaign-banner__indicator"]}
                  data-active={index === currentIndex}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(HomeCampaignBanner);
